import { render } from "./info.vue?vue&type=template&id=6947c83e&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=6947c83e&lang=scss&scoped=true"
import "./info.vue?vue&type=style&index=1&id=6947c83e&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6947c83e"]])

export default __exports__